const portal_instrument_model = require('civicsModels/portal_instrument_model');
const application_type_collection = require('civicsCollections/application_type_collection');
const scenario_model = require('civicsModels/portal/scenario_model');
const ViewManager = require('civicsUtils/view_manager');

define(function(require) {
	return {
		//'atrribute:value'
		//'attribute_nextLevel:value' <-- HTIS WONT WORK YET! Try to use this.buildDestination and pass the value
		// 'address_id:addresstuff_addrKey'
		// source:{addressstuff:{
		// 	addrKey:VALUE
		// }}
		// destination:{address:{
		// 	id:VALUE
		// }}
		parseOutputData: function(wizardData) {
			var retObj = {}
			if (wizardData && wizardData.outputData) {
				$.each(wizardData.outputData, function(index, el) {
					//process the value first;
					var val = el.value;
					var split = el.name.split(':');
					var dest;
					if (split.length == 2 ) {
						dest = split[0];
						var src = split[1];
						val = this.tryParseJSON(el.value)
						if ( val.validJSON ){
							var srcSplit = src.split('_')
							val = this.findVal(val.JSON, srcSplit)
						}
					}
					else {
						// the destination has no drill down
						dest = el.name;
					}
					if(val){
						//now setup the destination property
						var destSplit = dest.split('_');
						if (destSplit.length > 1 ) {
							//retObj = $.extend(true, {}, retObj, this.buildDestination(destSplit, val) );
							this.buildDestination(retObj, destSplit, val);
						}
						else {
							retObj[dest] = val;
						}
					}
				}.bind(this))
			}
			if(__DEV__){
				console.log("Parsed this ouput Data: ",retObj)
			}
			return retObj;
		},
		buildDestination(oParent, dest, val) {
			var top = dest;
			var haveDrillDown = false;
			// have drill down, build child
			if ( _.isArray(dest) && dest.length > 1 )
			{
				top = dest.shift();
				haveDrillDown = true;
			}
			else if ( _.isArray(dest) && dest.length == 1 )
			{
				top = dest[0];
			}
			var matches = [];
			var pattern = /\[(.*?)\]/g;
			var topId = '';
			var isPropArray = false;
			if ( top.includes('?') ){topId = top.substring(top.indexOf('?')+1);}
			while ((match = pattern.exec(top)) != null){matches.push(match[1]);}
			// if this level is an array
			if ( matches.length == 1 ){
				top = matches[0];
				isPropArray = true;
			}

			// find or create current property
			var oCurrProp =	oParent[top];
			if ( !oCurrProp ){
				//create new property for the currnet level
				if ( isPropArray ){
					var oProp = [];
					oParent[top] = oProp;
					oCurrProp = {};
					oCurrProp._internalId = topId;
					oProp.push(oCurrProp);
				}
				else{
					oCurrProp = {};
					oParent[top] = oCurrProp;
				}
			}
			else{
				if ( _.isArray(oCurrProp) ){
					// find the child or default to the first one
					var found = false;
					_.forEach(oCurrProp, function(o){
						if ( o._internalId == topId ){
							oCurrProp = o;
							found = true;
						}
					});
					if ( !found ){
						var newProp = {};
						newProp._internalId = topId;
						oCurrProp.push(newProp);
						oCurrProp = newProp;
					}
				}
			}

			if ( haveDrillDown ){
				this.buildDestination(oCurrProp,dest, val);
			}
			else{
				//set the value
				// todo: val can be an array in the future release.
				if( isPropArray){
					var newChild = {};
					newChild[top] = val;
					oParent.push(newChild);
				}
				else{
					oParent[top] = val;
				}
			}
		},
		findVal(value, attrs) {
			//if theres a value in attrs (just in case)
			if (attrs.length > 0) {
				//if there's a value in the value object associated with the current attr
				if (value[attrs[0]]) {
					//if we're on the last attribute name, just return the value
					if (attrs.length == 1) {
						return value[attrs[0]]
					}
					//if there are more attribute names, peel back another layer. Go Go Recursion!
					return this.findVal(value[attrs.shift()], attrs)
				}
			}
			//we didn't find anything, so don't return anything.
			return null;
		},
		tryParseJSON(str) {
			var parsed = ''
			var retObj = {
				JSON: '',
				validJSON: false
			}
			try {
				parsed = JSON.parse(str);
			} catch (e) {
				return retObj;
			}
			retObj.JSON = parsed
			retObj.validJSON = true
			return retObj;
		},
		createSavedInstrumentModel:function(instType, recType, scenarioID, associatedProjectID, outputData){
			var recordTypePromise = $.Deferred();
			var recordTypes = new application_type_collection();
			recordTypes.instrumentType = instType;
			recordTypes.removePageLimit = true;
			var selectQuery = ['id','code', 'description', 'showInPortal','portalInstructions'];

			recordTypes.urlParameters = {
				select: selectQuery,
				filter: {
					property: 'code',
					value: recType
				}
			};

			recordTypes.fetch({
				success: function() {
					recordTypePromise.resolve();
				}
			});
			var data = {};
			data.scenario = {};
			data.scenario.id = scenarioID;
			data.parentProjectID = associatedProjectID;
			var savedInstrument = new portal_instrument_model();
			savedInstrument.savePromise = $.Deferred()
			$.when(recordTypePromise).done(function() {
				var types = recordTypes.toJSON();
				var id;
				var portalInstructions;
				$.each(types, function(index, el) {
					if (el.code == recType) {
						id = el.id;
						portalInstructions = el.portalInstructions;
					}
				})
				data.applicationType = {
					code: recType,
					id: id,
					portalInstructions: portalInstructions
				}

				data = $.extend({}, data, outputData)
				var d = {
					project:data.parentProjectID,
					instrumentType: instType,
					instrumentData: JSON.stringify(data),
					scenario: {
						id: scenarioID
					},
					dataTypeCode:recType
				};
				savedInstrument.set(d);
				savedInstrument.save(null, {
					success: function() {
						this.savePromise.resolve();
					}.bind(savedInstrument)
				});
			});
			return savedInstrument;
		},
		//since the STOREJSON attribute is manually entered, we'll check it in a "user friendly" manner to grab it anyways if it's not cased correctly.
		getStoreJSON:function(outputData){
			const storeJSONString = 'storejson';
			let storeJSON = outputData[Object.keys(outputData).filter((k)=>{return k.toLowerCase() == storeJSONString})];//if the storeJSON attribute (any case) exists, grab the value
			return storeJSON && (storeJSON === true || storeJSON.toLowerCase().trim() === 'true');
		},
		createScenarioModelForCreatingProject:function(name,scenarioID,outputData, isCreateProject){
			var scenario = new scenario_model();
			var globalConfig = ViewManager.globalConfig().toJSON()
			var wizardProjectType = globalConfig.wizardProjectType
			let wizardOutput = null;
			var application = {
				applicationType: {
					code: wizardProjectType //get from global config
				},
				applicationDescription: i18n.t('CIVICS.COMMON.CPQ_WIZARD'),
				applicationContacts: [{
					contact: {
						id: ViewManager.currentUser().get('contactId.id')
					},
					isPrimary: true,
					isRespAccountHolder: true
				}],
				projectPhaseName: name
			}
			//store the CPQ Output data on the application if STOREJSON is set on the output data	
			if(this.getStoreJSON(outputData)){
				wizardOutput = {
					jsonValue:JSON.stringify(outputData)
				}
			}
			// -- end store json --

			application.address = outputData.address;
			application.parcel = outputData.parcel;
			application.Spatial = outputData.Spatial;
			let scenarioAttr = {
				id: scenarioID,
				wizardOutput:wizardOutput
			}; 
			if(isCreateProject)
			{ 
				scenarioAttr.application = application; 
			} 
			scenario.set(scenarioAttr);

			scenario.createProjectPromise = $.Deferred();
			scenario.save()
			.done(function(response, status, xhrResponse) {
				this.associatedProjectID = response.data.application.id;
				if (__DEV__) console.log('New Project ID', this.associatedProjectID);
				this.createProjectPromise.resolve();
			}.bind(scenario))
			.fail(function(response, status, xhrResponse){
				if (response.status === 401) {
					ViewManager.openAlert(i18n.t('CIVICS.COMMON.SESSION_LOST_ERROR'));
				}
				else {
					ViewManager.errorToWindow(response);
				}
			});;

			return scenario;
		},
		deleteScenario: function (scenarioID) {
			if(scenarioID && scenarioID > 1){
				var portalScenario = new scenario_model({
					id: scenarioID
				});
				return portalScenario.destroy();
			}
			return null;
		}
	}
});
